import retry from '@blockcatio/tabby-library/lib/utilities/retry';
import createPollerMiddleware from '@blockcatio/tabby-library/lib/utilities/poller';
import { walletDefinitions } from '@blockcatio/tabby-library/lib/utilities/walletTypes';
import timeout from '@blockcatio/tabby-library/lib/utilities/timeout';

import { isInteractive } from '../selectors/account';
import { accountChange, accountChangeFailed, accountNotProvided } from '../actions/account';
import { APP_INIT, APP_SHUTDOWN } from '../actionTypes';

const isProviderNotSet = error => error.message.indexOf('Provider not set') !== -1;
const isProviderNotDetected = error => error.message.indexOf('web3 provider detected') !== -1;
const isTimeoutError = error => error.name === 'TimeoutError';

const retryErrors = error =>
  !isProviderNotSet(error) && !isProviderNotDetected(error) && !isTimeoutError(error);

const accountNotProvidedErrors = error =>
  isProviderNotSet(error) || isProviderNotDetected(error) || isTimeoutError(error);

export default ({ walletManager }) => (store) => {
  const { dispatch } = store;
  return createPollerMiddleware(store, {
    frequency: 1000,

    initialState: { attempts: 0, previousWeb3Provided: null },

    // lifecycle is tied to the app itself
    checkStart: action => action.type === APP_INIT,
    checkStop: action => action.type === APP_SHUTDOWN,

    checkRun: (localState, state) => isInteractive(state),

    // main function body
    main: async ({ attempts, previousWeb3Provided }, state) => {
      const {
        account: {
          walletType, address, web3Locked, web3Provided,
        },
      } = state;
      const isConnected = !!address;
      const walletConfig = walletDefinitions.find(def => def.type === walletType);
      if (isConnected && !walletConfig.enablePolling) {
        return { attempts, previousWeb3Provided: web3Provided };
      }

      if (
        (previousWeb3Provided !== null && web3Provided === null) ||
        state.account.web3Provided === true ||
        attempts < 5
      ) {
        try {
          const timeoutMs = isConnected ? 10000 : 1000;

          const wallet = walletManager.get(walletType, address);
          const nextAddress = await retry(() => timeout(wallet.getAddress(), timeoutMs), {
            predicate: retryErrors,
          });

          // only dispatch when it changes or when it's locking
          if (nextAddress !== address) {
            if (nextAddress) {
              dispatch(accountChange(nextAddress));
            } else if (!web3Locked) {
              dispatch(accountChange(nextAddress));
            }

            return { attempts: 0, previousWeb3Provided: web3Provided };
          }

          return { attempts };
        } catch (error) {
          if (accountNotProvidedErrors(error)) {
            if (address) {
              dispatch(accountChange(''));
            }
            dispatch(accountNotProvided());
            return { attempts: attempts + 1, previousWeb3Provided: web3Provided };
          }

          dispatch(accountChangeFailed(error));
        }
      }
      return { attempts, previousWeb3Provided: web3Provided };
    },
  });
};



// WEBPACK FOOTER //
// ./src/middleware/pollAccount.js